import React from 'react';
import { StylesProvider, ThemeProvider, defaultTheme } from '@nextiva/next-ui-components';
import PropTypes from 'prop-types';
import { StyledGlobalHeaderContainer } from './GlobalHeaderContainer.styled';
import { GlobalHeader } from './GlobalHeader';
import { GlobalHeaderWithHookContainer } from './GlobalHeaderWithHookContainer';

const blockName = 'NuiGlobalHeaderContainer';

export const GlobalHeaderContainer = ({ children, shouldUseGlobalHeader, ...props }) => {
  let content = null;

  if (shouldUseGlobalHeader) {
    const {
      globalStoreData,
      firstName,
      lastName,
      appName,
      canShowWaffleMenu,
      showLogo,
      canShowCalendar,
      avatarMenuOptions,
      onSignOut,
      presenceStatus,
    } = props;
    content = (
      <GlobalHeader
        appName={appName}
        globalStoreData={globalStoreData}
        firstName={firstName}
        lastName={lastName}
        hasWaffleMenu={canShowWaffleMenu}
        showLogo={showLogo}
        avatarMenuOptions={avatarMenuOptions}
        hasCalendar={canShowCalendar}
        onSignOut={onSignOut}
        presenceStatus={presenceStatus}
      >
        {children}
      </GlobalHeader>
    );
  } else {
    content = <GlobalHeaderWithHookContainer {...props}>{children}</GlobalHeaderWithHookContainer>;
  }

  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={defaultTheme}>
        <StyledGlobalHeaderContainer id="global-header-container" className={`${blockName}-root`}>
          {content}
        </StyledGlobalHeaderContainer>
      </ThemeProvider>
    </StylesProvider>
  );
};

GlobalHeaderContainer.propTypes = {
  globalStoreData: PropTypes.object,
  shouldUseGlobalHeader: PropTypes.bool,
  canShowWaffleMenu: PropTypes.bool,
  showLogo: PropTypes.bool,
  canShowCalendar: PropTypes.bool,
  avatarMenuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  onSignOut: PropTypes.func,
  presenceStatus: PropTypes.string,
};

GlobalHeaderContainer.defaultProps = {
  shouldUseGlobalHeader: false,
  canShowWaffleMenu: true,
  canShowCalendar: false,
  avatarMenuOptions: [],
  presenceStatus: '',
};

GlobalHeaderContainer.displayName = 'GlobalHeaderContainer';
